module.exports = __webpack_public_path__ + "img/0100.bdd4bdc1.jpg";